export default __webpack_public_path__ + "imgs/03f39e5aa455c243628fa9ff14f5f397.png";